<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <span class="upload-group">
      <el-checkbox-group v-model="$attrs.model[item.field]" :ref="item.field" style="display: none"></el-checkbox-group>
      <!-- <el-input v-model="$attrs.model[item.field]" :ref="item.field" style="display: none"> </el-input> -->
      <el-upload
        :action="upAddr"
        :limit="5"
        :on-success="uploadSuccess"
        :before-remove="removeHandle"
        :file-list="fileList"
        :disabled="item.options.disabled"
        style="min-height: 29px"
        accept=".pdf, .doc, .docx, .xls, .xlsx"
      >
        <el-button type="text" size="medium" style="padding: 0">上传<i class="el-icon-upload el-icon--right"></i></el-button>
      </el-upload>
    </span>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  computed: {
    fileList() {
      let arr = [];
      if (this.item.val) {
        this.item.val.forEach((item) => {
          arr.push({ name: item.fileName, url: item.fileUrl });
        });
      }
      return arr;
    },
    upAddr() {
      return window.SITE_CONFIG.fileUpload;
    },
  },

  methods: {
    uploadSuccess(res, file, fileList) {
      console.log(res);
      console.log(file);
      console.log(fileList);
      console.log(this.$attrs.model[this.item.field]);

      if (res.code === 200) {
        let arr = [];
        arr.push(res.data.storage);
        if (this.item.val) {
          arr = arr.concat(this.item.val);
        }

        this.$set(this.$attrs.model, this.item.field, arr);
      }
    },
    removeHandle(file, fileList) {
      console.log(this.$attrs.model[this.item.field]);
      console.log(file);
      console.log(fileList);
      let arr = this.$attrs.model[this.item.field] || [];
      fileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          arr.splice(index, 1);
          this.$attrs.model[this.item.field] = arr;
          console.log(index);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
